import React from "react";
import "./BrandName.scss";

function BrandName({ isFooter = false }) {
  return (
    <div className={`brand ${isFooter === true ? "footer" : ""}`}>
      <span>Pose.Lively</span>
    </div>
  );
}

export default BrandName;
